// extracted by mini-css-extract-plugin
export default {"MobileOrb":"MobileAskAicaOrb_MobileOrb__l1Ebt","OrbImage":"MobileAskAicaOrb_OrbImage__o4qy1"};